/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */


import React from 'react';
import { SurveyNoteInstructionsProps } from './types';
import { SurveyNoteInstructions } from './SurveyNoteInstructions';
import { RichTextEditorContainer } from '../../components/rich-text-editor/RichTextEditor';


// Simple wrapper to attached editor context and init the state
export const NoteInstructionContainer = (props: SurveyNoteInstructionsProps) => {
  return (
    <RichTextEditorContainer key={props.editorId}>
      <SurveyNoteInstructions {...props} />
    </RichTextEditorContainer>
  )
}
